import sdk from '@/sdk';
import {PUBLISH_STATUS} from './../../constants/document/square';
import {IPublishSquareData} from './../../interface';

export const isPublishToPerson = (publishToSquareData?: IPublishSquareData) => {
    if (!publishToSquareData) {
        return false;
    }
    return [
        PUBLISH_STATUS.bothPublishToSquareAndPersonalPage,
        PUBLISH_STATUS.onlyPublishToPerson,
    // @ts-ignore
    ].includes(publishToSquareData.status);
};

export const isPublishOnlyToPerson = (publishToSquareData?: IPublishSquareData) => {
    if (!publishToSquareData) {
        return false;
    }
    return publishToSquareData.status === PUBLISH_STATUS.onlyPublishToPerson;
};

export const isCurUserPublisher = (publishToSquareData?: IPublishSquareData) => {
    if (!publishToSquareData) {
        return false;
    }
    return publishToSquareData.operatorGuid === sdk.as.user?.userGuid;
};

export const isSynchronizedLatest = (publishToSquareData?: IPublishSquareData) => {
    if (!publishToSquareData) {
        return false;
    }
    return !publishToSquareData.published;
};
